import { BoolFlag } from '@gp/enums/common';
import { MilestoneDateStatus } from '@gp/enums/milestone';

import type { IMilestone } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';

export const DEFAULT_MILESTONE: IMilestone = {
  id: '',
  project_id: '',
  project: '',
  parent_milestone_id: '',
  milestone_id: '',
  milestone: '',
  is_gr: BoolFlag.False,
  is_launch: BoolFlag.False,
  milestone_gate_review: null,
  milestone_history: [],
  action_items: [],
  approved_budget_to_next: '',
  approved_budget_to_next_history: [],
  // 暂时没用这个字段了
  budget_history: [],
  budget_next_milestone: '',
  cadence: '',
  date: '',
  date_confirm: MilestoneDateStatus.Confirm,
  dev_budget: '',
  dev_cost: '',
  dev_cost_history: [],
  dev_cost_actual: '',
  dev_cost_actual_history: [],
  key_milestones_financial: [],
  key_milestones_financial_forecast: [],
  gate_review: '',
  gate_review_decision: '',
  gate_review_status: '',
  key_feedback: '',
  key_question: '',
  man_month: '',
  material: [],
  next_checkpoint: '',
  next_deliverables: '',
  next_milestone_scope: '',
  progress: '',
  scope_of_deliverables_explain: '',
  scope_of_deliverables_link: '',
  is_del: '',
  modify_personnel: '',
  update_time: '',
  updatetime: '',
  create_time: '',
};
